import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { animateScroll } from 'react-scroll';

import { useSelector } from 'react-redux';
import { APP_LANGS } from 'state/app';
import { SingleProduct } from './SingleProduct';

const SingleProductView = () => {
   const params = useParams();
   const currentLang = useSelector((state) => getLanguage(state.app.lang));

   const innerWrapperRef = useRef(null);
   const [content, setContent] = useState(null);
   const [loading, setLoading] = useState(false);
   const [image, setImage] = useState('');

   const getData = useCallback(async () => {
      setLoading(true);

      const { data } = await axios.get(`/wp/v2/posts/${params?.productId}`);

      if (!data?.translations) {
         setLoading(false);
         return;
      }

      const contentLang = data.translations;
      const productId = contentLang[currentLang];

      if (!productId) {
         setLoading(false);
         return;
      }

      await axios.get(`/wp/v2/posts/${productId}`).then(({ data }) => {
         axios.get(`/wp/v2/media/${data?.featured_media}`).then(({ data: mediaData }) => {
            setImage(mediaData?.source_url);
         });

         setContent({
            title: data?.title?.rendered || '',
            content: data?.content?.rendered || '',
            categories: data.categories,
            konstrukcja: data?.acf?.konstrukcja,
            slup_z_automatem: data?.acf?.slup_z_automatem,
            informator: data?.acf?.informator,
            elementy_konstrukcyjne: data?.acf?.elementy_konstrukcyjne,
            podzial_slupkow: data?.acf?.podzial_slupkow,
            slupki_do_bram_uchylnych: data?.acf?.slupki_do_bram_uchylnych,
            wypelnienie: data?.acf?.wypelnienie,
            dlugosc_bram: data?.acf?.dlugosc_bram,
            waga: data?.acf?.waga,
            przekroj_slupka: data?.acf?.przekroj_slupka,
            wysokosc_bram__slupka: data?.acf?.wysokosc_bram__slupka,
            informacje: data?.acf?.informacje,
            ilosc_pol_w_swietle: data?.acf?.ilosc_pol_w_swietle,
            dostepne_wysokosci: data?.acf?.dostepne_wysokosci,
            przeciwwagi_do_bram: data?.acf?.przeciwwagi_do_bram,
            akcesoria: data?.acf?.akcesoria,
            akcesoria_opis: data?.acf?.akcesoria_opis,
            akcesoria_druga_linia: data?.acf?.akcesoria_druga_linia,
            akcesoria_druga_linia_opis: data?.acf?.akcesoria_druga_linia_opis,
            akcesoria_trzecia_linia: data?.acf?.akcesoria_trzecia_linia,
            akcesoria_trzecia_linia_opis: data?.acf?.akcesoria_trzecia_linia_opis,
            konstrukcja_nosna: data?.acf?.konstrukcja_nosna,
            informacje_techniczne: data?.acf?.informacje_techniczne,
            montaz: data?.acf?.montaz,
            ilosc_nitow: data?.acf?.ilosc_nitow,
            rodzaje_przesel: data?.acf?.rodzaje_przesel,
            rodzaje_przesel_z_opisem: data?.acf?.rodzaje_przesel_z_opisem
         });
      });

      animateScroll.scrollToTop();
      setLoading(false);
   }, [params, currentLang]);

   useEffect(() => {
      getData();
   }, [getData]);

   return (
      <SingleProduct
         content={content}
         image={image}
         innerWrapperRef={innerWrapperRef}
         loading={loading}
      />
   );
};

function getLanguage(lang) {
   switch (lang) {
      default:
      case APP_LANGS.POL:
         return 'pl';
      case APP_LANGS.ENG:
         return 'en';
      case APP_LANGS.UKR:
         return 'uk';
      case APP_LANGS.GER:
         return 'de';
   }
}

export default SingleProductView;
